<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout style="margin-top: 5%">
          <v-flex xs12 sm12 md4 lg4 offset-md4 offset-lg4>
            <br>
            <br>
            <v-card flat>
              <br/>
              <br/>
              <img style="padding-left: 25%; padding-right: 25%" src="@/assets/Back/images/ol-pejeta-logo.svg" width="100%" alt="logo">
              <v-container>
                <v-form lazy-validation @submit.prevent="doAuth()">
                  <v-text-field
                    v-model="login.email"
                    label="E-mail"
                    required
                    type="email"
                  ></v-text-field>
                  <v-text-field
                    v-model="login.password"
                    label="Password"
                    required
                    type="password"
                  ></v-text-field>
                  <v-btn :depressed="true" type="submit" color="primary" :loading="$loadingTrue">
                    Login
                  </v-btn>
                  <router-link :to="{name: 'ResetPassword'}">Forgotten password?</router-link>
                </v-form>
              </v-container>
            </v-card>
            <br>
            <br>
            <v-layout>
              <v-flex xs2 sm2 md2 lg2 offset-xs1 offset-sm1 offset-md1 offset-lg1>
                <img style="padding: 5%" src="@/assets/Both/Logos/BoranBeefLogoHorizontal.png" width="100%" alt="logo">
              </v-flex>
              <v-flex xs2 sm2 md2 lg2>
                <img style="padding: 5%" src="@/assets/Both/Logos/MoraniCenterLogo_horizontal.png"  width="100%" alt="logo">
              </v-flex>
              <v-flex xs2 sm2 md2 lg2>
                <img style="padding: 5%" src="@/assets/Both/Logos/SweewatersSanctuaryLogo_horizontal.png" class="m-b" width="100%" alt="logo">
              </v-flex>
              <v-flex xs2 sm2 md2 lg2>
                <img style="padding: 5%" src="@/assets/Both/Logos/OPRanchingLogo.png" class="m-b" width="100%" alt="logo">
              </v-flex>
              <v-flex xs2 sm2 md2 lg2>
                <img style="padding: 5%" src="@/assets/Both/Logos/Safari_Diner_logo.png" class="m-b" width="100%" alt="logo">
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
  
</template>

<script>
export default {
  data () {
    return {
      login: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    doAuth: function () {
      this.$store.dispatch('loading_true')
      this.$store.dispatch('do_login', this.login)
    }
  }
}
</script>

<style>

</style>
